export const ekConstants = {
    SET_EK: 'EK_SET_EK',
    SET_PRODUCT: 'EK_SET_PRODUCT',
};
